import clsx from 'clsx'
import CoordinateSystem from '../../../../components/discover/aivy-pdf-reports/components/graphs/CoordinateSystem'

export default function CulturalFitDimensionMatchMessage({
  companyCultureScores,
  userCultureScores,
  className
}) {
  return (
    <div
      className={clsx(
        'w-full rounded-lg border border-lightGrey bg-paleWhiteBlue/40 px-6 py-4',
        className
      )}
    >
      <CoordinateSystem
        companyCultureScores={companyCultureScores}
        userCultureScores={userCultureScores}
      />
    </div>
  )
}
